<div class="d-flex flex-row justify-content-between align-items-center">
  <h5>{{ 'CASES.single.general.relation_list.case_creditor_status_logs.heading' | translate }}</h5>
</div>
<div class="pt-4" *ngIf="isLoading">
  <mat-spinner class="m-0 m-auto"></mat-spinner>
</div>
<app-empty-dataset [show]="!isLoading && !caseCreditorStatusLogs?.length"
                   [message]="'CASES.single.general.relation_list.case_creditor_status_logs.empty_dataset' | translate">
</app-empty-dataset>
<div class="row m-2" *ngFor="let statusLog of caseCreditorStatusLogs" [hidden]="isLoading">
  <!--<div class="mb-2">{{caseCreditorStatusLog.creditor.name}}</div>-->
  <div class="card col-12 mt-1">
    <div class="card-body">
      <span *ngIf="statusLog.from_status">
        {{ 'CASES.single.general.relation_list.case_creditor_status_logs.status_changed_from' | translate }} {{ statusLog.from_status.name_en }}
      </span>
      <span
        *ngIf="!statusLog.from_status">
        {{ 'CASES.single.general.relation_list.case_creditor_status_logs.no_old_status' | translate }}
      </span>
      <span *ngIf="statusLog.to_status">
        {{ ' ' }} {{ 'CASES.single.general.relation_list.case_creditor_status_logs.status_changed_to' | translate }} {{ statusLog.to_status.name_en }}
      </span>
      <span *ngIf="statusLog.user">
        {{ ' ' }} {{ 'CASES.single.general.relation_list.case_creditor_status_logs.status_changed_by' | translate }} {{ statusLog.user.name }}
      </span>
      <p>{{ statusLog.created_at| toDateObject | date: 'medium' }}</p>
    </div>
  </div>
</div>
